module.exports = __webpack_public_path__ + "aa75ee768ac4f1aeb4f0c5c4126375f7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/emojis/score-3.svg
// module id = 163
// module chunks = 0